import { render, staticRenderFns } from "./TableTerceiros.vue?vue&type=template&id=1d840a9c&scoped=true&"
import script from "./TableTerceiros.vue?vue&type=script&lang=js&"
export * from "./TableTerceiros.vue?vue&type=script&lang=js&"
import style0 from "./TableTerceiros.vue?vue&type=style&index=0&id=1d840a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d840a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
